import { useState, type FormEvent, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface EvidenceRow {
  readonly evidenceId: string;
  readonly evidenceType: string;
  readonly evidenceName: string;
  readonly versionNumber: number;
  readonly isLocked: boolean;
}

export function M21EvidenceRepositoryPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [executionId, setExecutionId] = useState('');
  const [rows, setRows] = useState<EvidenceRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  function onSubmit(e: FormEvent): void {
    e.preventDefault();
    const id = executionId.trim();
    if (!id) return;
    setLoading(true);
    setError(null);
    setRows(null);
    apiRequest<{ data: EvidenceRow[] }>(`/v1/audit/evidence/by-execution/${encodeURIComponent(id)}`, { token })
      .then((r) => setRows(r.data))
      .catch((err) => setError((err as Error).message))
      .finally(() => setLoading(false));
  }

  return (
    <main aria-label="evidence-repository">
      <h1>{t('m21.evidence.title')}</h1>
      <form aria-label="evidence-search-form" onSubmit={onSubmit}>
        <label htmlFor="executionId">{t('m21.evidence.executionIdLabel')}</label>
        <input
          id="executionId"
          name="executionId"
          value={executionId}
          onChange={(e) => setExecutionId(e.target.value)}
        />
        <button type="submit">{t('m21.evidence.loadButton')}</button>
      </form>
      {error && <p role="alert">{error}</p>}
      {loading && <p>{t('m21.evidence.loading')}</p>}
      {rows && (
        <table aria-label="evidence-table">
          <thead><tr><th>{t('m21.evidence.colType')}</th><th>{t('m21.evidence.colName')}</th><th>{t('m21.evidence.colVersion')}</th><th>{t('m21.evidence.colLocked')}</th></tr></thead>
          <tbody>
            {rows.map((ev) => (
              <tr key={ev.evidenceId}>
                <td>{ev.evidenceType}</td>
                <td>{ev.evidenceName}</td>
                <td>{ev.versionNumber}</td>
                <td>{ev.isLocked ? t('m21.evidence.yes') : t('m21.evidence.no')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  );
}
